import { MetaradarStateSnapshot } from '@app/model/metaradar/MetaradarStateSnapshot';
import _isEmpty from 'lodash/isEmpty';
import Message from '@app/component/message/Message';
import React from 'react';
import { findProviderData } from '@app/component/provider/FindProviderData';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import Utilities from '@util/Utilities';


const MetaradarDailyReportUndercutsAnalysisFragment: React.FunctionComponent<{
	metaradarStateSnapshot: MetaradarStateSnapshot
}> = ({ metaradarStateSnapshot }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	if (_isEmpty(metaradarStateSnapshot.dailyItems)) {
		return <Message state="info">There are no results found!</Message>;
	}

	const statistics = metaradarStateSnapshot.findStatisticsPerProvider(companyHotel.metaradarSettings!.threshold || 0.9);

	if (_isEmpty(statistics)) {
		return <div className="p-6"><Message state="info">No results found!</Message></div>;
	}

	const sortedStatistics = statistics!.sort((a, b) => b.percentageOfTotalUndercuts - a.percentageOfTotalUndercuts);

	return <div className="w-full shadow ring-1 ring-black ring-opacity-5">
		<div className="overflow-x-auto overflow-y-auto max-h-[70dvh]">
			<div className="inline-block min-w-full align-middle">
				<table className="min-w-full divide-y divide-gray-300">
					<thead className="sticky-table-header">
					<tr className="divide-x divide-gray-200">
						<th scope="col" className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Channel</th>
						<th scope="col" className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Percentage of
							Undercuts
						</th>
						<th scope="col" className="px-3 py-3 text-left text-sm font-semibold text-gray-900">Avg Undercut</th>
					</tr>
					</thead>
					<tbody className="divide-y divide-gray-200">

					{sortedStatistics.map((stat, index) => <tr key={`provider_stats_${index}`} className="divide-x divide-gray-200">
								<td
									className="whitespace-nowrap px-3 py-4 text-sm font-medium text-gray-900">
									<div className="flex items-center gap-x-2">
										<img
											className="block h-4 w-4"
											alt={findProviderData(stat.provider).name}
											title={findProviderData(stat.provider).name}
											src={`https://${stat.iconUrl}`}
										/>
										<span>{findProviderData(stat.provider).name}</span>
									</div>
								</td>
								<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
									{stat.percentageOfTotalUndercutsPercentage}
								</td>
								<td
									className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
									{Utilities.formatDouble(stat.avgDifference, 0)}%
								</td>
							</tr>,
						)}
					</tbody>
				</table>
			</div>
		</div>
	</div>;
};

export default MetaradarDailyReportUndercutsAnalysisFragment;